import React from 'react';

const TICK_MS = 250;

/**
 * Whole seconds left until `availableAt` (0 when there is nothing to wait for). It is computed from the clock on
 * every render, so it never drifts, and it re-renders four times a second only while it is counting down.
 */
export const useSecondsLeft = (availableAt: number | null): number => {
    const [, setTick] = React.useState(0);
    const remainingMs = availableAt === null || Number.isNaN(availableAt) ? 0 : availableAt - Date.now();
    const waiting = remainingMs > 0;

    React.useEffect(() => {
        if (!waiting) {
            return undefined;
        }
        const timer = setInterval(() => setTick((current) => current + 1), TICK_MS);
        return () => clearInterval(timer);
    }, [waiting, availableAt]);

    return waiting ? Math.ceil(remainingMs / 1000) : 0;
};
